
import { Button } from "@/components/ui/button";
import { Share as ShareIcon } from "lucide-react";
import { toast } from "sonner";

interface ShareButtonProps {
  title: string;
  url?: string;
}

const ShareButton = ({ title, url }: ShareButtonProps) => {
  const handleShare = async () => {
    // Use the current URL if none is provided
    const shareUrl = url || window.location.href;
    
    // Check if the Web Share API is available
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: shareUrl,
        });
        toast.success("Shared successfully!");
      } catch (error) {
        console.error("Error sharing:", error);
        // Fall back to copy to clipboard if sharing was canceled or failed
        copyToClipboard(shareUrl);
      }
    } else {
      // Fall back to copy to clipboard
      copyToClipboard(shareUrl);
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success("Link copied to clipboard");
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
        toast.error("Failed to copy link");
      });
  };

  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={handleShare}
      className="flex items-center gap-2"
    >
      <ShareIcon size={16} />
      Share
    </Button>
  );
};

export default ShareButton;
